<template>
  <div v-if="indexChild < 9">
    <div
      class="mv-slider__big__item--cont"
      v-if="!isLoadingChild"
    >
      <a class="itemstatus__new" :target="(sliderBigChild.acf?.link_type === 'PDF掲載' || sliderBigChild.acf?.link_type === '外部サイト') ? '_blank' : '_self'" v-if="sliderBigChild.acf.link_type !== '遷移先なし'" :href="generateLink(sliderBigChild)">
        <div class="itemstatus__new__banner" v-if="diffDate(sliderBigChild.acf?.start_date) <= 7">
          <img src="@/assets/img/top/portal_icon.svg" alt="" />
          <div class="itemstatus__new__banner__text">NEW</div>
        </div>
        <div class="cont-img" v-if="sliderBigChild.acf?.banner_image">
          <img :src="$func.formatUrl(sliderBigChild.acf?.banner_image)" alt="" />
        </div>
      </a>
      <div class="itemstatus__new" v-else>
        <div class="itemstatus__new__banner" v-if="diffDate(sliderBigChild.acf?.start_date) <= 7">
          <img src="@/assets/img/top/portal_icon.svg" alt="" />
          <div class="itemstatus__new__banner__text">NEW</div>
        </div>
        <div class="cont-img" v-if="sliderBigChild.acf?.banner_image">
          <img :src="$func.formatUrl(sliderBigChild.acf?.banner_image)" alt="" />
        </div>
      </div>
    </div>

    <div class="skeleton-parent" v-if="isLoadingChild">
      <div v-for="(n, indexChild) in 6" :key="indexChild" class="skeleton-child">
        <PuSkeleton :count="10"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Fragment } from "vue-fragment";
import { formatDate, diffDate } from '@/utils/helper';

export default {
  name: "SliderBig",
  // data() {
  //   return {
  //     linkCustom: ''
  //   }
  // },
  props: {
    sliderBigChild: {
      type: Object,
    },
    indexChild: {
      type: Number
    },
    isLoadingChild: {
      type: Boolean
    }
  },
  components: {
    Fragment
  },

  computed: {},

  methods: {
    formatDate, 
    diffDate,
    formatUrl(url = '') {
        if (url === false) url = '';
        url = url.replace(process.env.VUE_APP_BASE_URL_CMS, process.env.VUE_APP_BASE_URL_FE);
        return url;
    },
    generateLink(item) {
      let link = '/';
      switch (item.acf?.link_type) {
        case 'PDF掲載':
          link = this.formatUrl(item.acf?.pdf);
          break;
        case '外部サイト':
          link = item.acf?.link_url;
          break;
        case 'タウンポータル内詳細リンク':
          switch (item.acf?.townportal_link) {
            case 'お知らせ':
              link = `/information/${item.acf?.townportal_link_id}`;
              break;
            case 'ショップニュース':
              link = `/shop-news/${item.acf?.townportal_link_id}`;
              break;
            case 'イベントニュース':
              link = `/event/${item.acf?.townportal_link_id}`;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
      return link;
    }
  },
};
</script>
